const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isDataverseGuid(value) {
  return typeof value === 'string' && GUID_REGEX.test(value);
}

export function isDemoRecordId(value) {
  if (typeof value !== 'string') {
    return false;
  }

  return /^(INN|LK)\d+$/i.test(value);
}

/** OData entity key — must be a Dataverse record GUID. */
export function formatDataverseRecordKey(recordId) {
  if (!isDataverseGuid(recordId)) {
    throw new Error(
      `Ugyldig Dataverse-post-ID («${recordId}»). Forventet GUID fra Dataverse, ikke demo-ID.`
    );
  }

  return recordId;
}
